module.exports = "<app-main-nav></app-main-nav>\n"